import { FormControl, FormErrorMessage, FormHelperText, FormLabel } from "@chakra-ui/react";
import { t } from "i18next";
import { useCallback } from "react";
import { useCreateUploadForBseBidDescriptionMutation } from "../../../../autogen/bff-api";
import { getFileExtension } from "../../../../common/documents/utils";
import { TipTap, TipTapCreatePostRequest } from "../../../../common/input/TipTap/TipTap";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { editBasicBidThunk } from "../../../../common/redux/thunks/basic-bid/edit-basic-bid-thunk";
import { useBasicBidState } from "../../../sourcing-events/useBasicBidEventState";

export const Comment = () => {
  const dispatch = useAppDispatch();
  const bidState = useBasicBidState();
  const value = bidState.comment.value;
  const errorMessage = bidState.comment.errorMessage;
  const [createUploadForDescription] = useCreateUploadForBseBidDescriptionMutation();

  const createPostRequest = useCallback<TipTapCreatePostRequest>(
    async ({ uploadId, file }) =>
      createUploadForDescription({
        bidId: bidState.id,
        uploadId,
        createUploadRequestDto: {
          fileName: file.name,
          fileSize: file.size,
          fileExtension: getFileExtension(file.name),
          mimeType: file.type,
        },
      }).unwrap(),
    [createUploadForDescription, bidState.id]
  );

  return (
    <>
      <FormControl id="description" mt={"10px"} isInvalid={errorMessage !== null} p="1">
        <FormLabel>{t("Bid comment")}</FormLabel>
        <TipTap
          content={value ?? ""}
          onUpdate={(value) => {
            dispatch(
              editBasicBidThunk({
                command: {
                  type: "EditComment",
                  value: value,
                },
              })
            );
          }}
          editable={true}
          createPostRequest={createPostRequest}
          documents={bidState.commentDocuments.value}
        />
        <FormHelperText>{t("Please provide a short comment to your bid")}</FormHelperText>
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      </FormControl>
    </>
  );
};
